module.exports = __webpack_public_path__ + "img/closed.c349de6b.svg";